import { Image } from 'antd-mobile';
import './About.less'
import addressPng from '@/image/map/address.png'

const About = (props:any) => {

  return (
    <section className='about-page'>
      <h1>安徽悠悦软件科技有限公司</h1>

      <p>软件介绍：UU语音，开启全新社交之旅。以声会友，畅聊心声。分享生活点滴，用UU搭建起情感桥梁，让你在多元声音世界中，找到契合的陪伴，收获真挚情谊，告别孤单，拥抱温暖社交圈。</p>

      <p>公司宗旨：安徽悠悦软件科技有限公司，旗下独立开发运营的语音软件平台“UU语音”，以“用声音绽放多彩生活”为使命，致力于打造一个让年轻人感受到声音温暖的多彩社交圈。</p>

      <p>
        公司地址：
        <span>安徽省铜陵市义安区东联镇毛桥街道177-201</span>
      </p>

      <p className='special'>邮箱: <a href="mailto:kefu@love-uu.com">kefu@love-uu.com</a></p>
      <p className='special'>联系方式：05628292966</p>
      <p className='special'>工作日: 10:00-22:00</p>
      {/* <p className='special'>
        线上留言请至微信公众号 "
        <b>UU语音app</b>
        " 联系在线客服
      </p> */}

      <Image src={addressPng} fit='contain' />
    </section>
  )
}

export default About